module.exports = __webpack_public_path__ + "img/404.fd7f0908.svg";